import {CSSProperties} from "react";
import {mergeStyles} from "../types";
import {DeepPartial} from "@reduxjs/toolkit";

export type FancyCodeStyleSheet = {[key: string]: CSSProperties};
export type CodeStyleSheet = DeepPartial<FancyCodeStyleSheet>;

export const defaultCodeStyle: {[key: string]: CSSProperties} = {
    "": {
        color: "#000000"
    },
    "keyword": {
        color: "#ff8800",
        fontWeight: 700
    },
    "literal": {
        color: "#0050a0",
        fontWeight: 400
    },
    "class": {
        color: "#8040a0",
        fontWeight: 400
    },
    "function": {
        color: "#0060c0a0",
        fontWeight: 400
    },
    "type def": {
        color: "#00306080",
        fontWeight: 400,
        /*fontSize: "0.8em",
        borderRadius: 4,
        background: "#0030600b",
        fontFamily: "Open Sans",
        paddingLeft: 4,
        paddingRight: 4,
        position: "relative",
        bottom: "0.1em",
        margin: 2*/
    }
}

export const defaultCodeStyleDark = mergeStyles({
    "": {
        color: "#b4c8dc"
    },
    "keyword": {
        color: "#ff8800"
    },
    "literal": {
        color: "#5080c0"
    },
    "class": {
        color: "#8040a0"
    },
    "function": {
        color: "#0060c0a0"
    },
    "type def": {
        color: "#506077"
    }
}, defaultCodeStyle);